import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyPhonesTranscriptionNotAvailable = lazy(() => import('./svg-components/phones-transcription-not-available'));

const PhonesTranscriptionNotAvailable = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyPhonesTranscriptionNotAvailable {...rest} />
  </Suspense>
);

export default PhonesTranscriptionNotAvailable;
